/* eslint-disable react/prop-types */
import React from 'react';
import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';
import classnames from 'classnames';
import { ArrowLeft24Regular } from '@fluentui/react-icons';
import { Button } from '@fluentui/react-components';

const getStyles = () => ({
  sdkPageNavigationHeader: {
    marginTop: 12,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    height: 32,
    padding: '0 43px',
  },
  backBtn: {
    color: '#0F6CBD',
  },
  title: {
    margin: 0,
    fontSize: 26,
    lineHeight: '32px',
    color: '#242424',
  },
});

interface ISDKPageNavigationHeader {
  title: string;
  onClickBackButton: () => void;
}

export const SDKPageNavigationHeader: React.FC<ISDKPageNavigationHeader> = React.memo(({ title, onClickBackButton }) => {
  const classes = useDefaultStyles(getStyles);

  return (
    <div className={classnames(classes.sdkPageNavigationHeader, 'sdk-page-navigation-header')}>
      <Button
        appearance="transparent"
        icon={<ArrowLeft24Regular className={classnames(classes.backBtn, 'back-btn')} />}
        onClick={onClickBackButton}
      />
      <h2 className={classes.title}>{title}</h2>
    </div>
  );
});
